import React from "react";
import "./SlotGamesDevelopmentStyle.scss";
import { slotGamesDevelopmentTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "components/Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const SlotGamesDevelopmentSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/contact-us`);
  };

  return (
    <section className="slot-games-development-section">
      <div className="slot-games-development-wrap">
        <SectionHeading>{slotGamesDevelopmentTextContent.headingText}</SectionHeading>

        <div className="slot-games-development-box">
          <div className="cards-grid">
            {slotGamesDevelopmentTextContent.content.map((section, index) => (
              <div className="card" key={index}>
                <div className="card-header">
                  <div className="icon-box">
                    <img src={section.iconSrc} alt="Image" />
                  </div>
                  <h5 className="title-text">{section.titleText}</h5>
                </div>

                <div className="card-body">
                  <p className="para-text">{section.paraText}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="btn-box">
            <CustomButton
              buttonType="secondary"
              label={slotGamesDevelopmentTextContent.btnText}
              onClick={handleButtonClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SlotGamesDevelopmentSection;
